import config from 'config';
import { http_client } from './api';

const getList = async (
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  jenjang_id = null,
  mapel_id = null,
  bab_id = null
) => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (perPage) params.append('perPage', perPage);
  if (sort) params.append('sort', sort);
  if (orderBy) params.append('orderBy', orderBy);
  if (search) params.append('search', search);
  if (jenjang_id) params.append('jenjang_id', jenjang_id);
  if (mapel_id) params.append('mapel_id', mapel_id);
  if (bab_id) params.append('bab_id', bab_id);
  const url = config.apiUrl + 'materi/all' + (params.toString() ? '?' + params.toString() : '');
  return http_client.get(url).then((response) => response.data).catch((error) => {
    throw error;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'materi/' + id).then((response) => {
    return response.data;
  });
};

const getFile = async (id) => {
  return http_client.get(config.apiUrl + 'materi/file/' + id).then((response) => {
    return response.data;
  });
};

const getRating = async (id) => {
  return http_client.get(config.apiUrl + 'materi/' + id + '/rating').then((response) => {
    return response.data;
  });
};

const storeRating = async (id, data) => {
  return http_client.post(config.apiUrl + 'materi/' + id + '/rating', data).then((response) => {
    return response.data;
  });
};

const MateriService = {
  getList,
  read,
  getFile,
  getRating,
  storeRating
};

export default MateriService;
